import App from "App";
import dayjs from "dayjs";
import "dayjs/locale/ru";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import utc from "dayjs/plugin/utc";
import "index.scss";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

import { store } from "app/store";

// Модифицируем dayjs
dayjs.locale("ru");
dayjs.extend(utc);
dayjs.extend(isSameOrBefore);

// Запускаем приложение
const container = document.getElementById("root")!;
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
